import type { GridApi, IRowNode } from 'ag-grid-community';

export function setGridRowData<T = unknown>(api: GridApi<T>, rowData: T[]): void {
  api.setGridOption('rowData', rowData);
}

type GridDragAndDropInternal = {
  addDropTarget: (t: unknown) => void;
  removeDropTarget?: (t: unknown) => void;
};

export function getGridDragAndDropService(api: GridApi): GridDragAndDropInternal | undefined {
  const withBeans = api as GridApi & {
    beans?: { dragAndDropService?: GridDragAndDropInternal; dragAndDrop?: GridDragAndDropInternal };
  };
  return withBeans.beans?.dragAndDropService ?? withBeans.beans?.dragAndDrop;
}

export function getDisplayedNeighborRowForSelection(
  api: GridApi,
  rowIndex: number | null | undefined,
): IRowNode | undefined {
  if (rowIndex == null) {
    return undefined;
  }
  return api.getDisplayedRowAtIndex(rowIndex) ?? api.getDisplayedRowAtIndex(rowIndex - 1);
}

export function getDisplayedRowIndexNearScrollPixel(api: GridApi, pixel: number): number | undefined {
  const count = api.getDisplayedRowCount();
  if (count <= 0 || pixel < 0) {
    return undefined;
  }
  let lo = 0;
  let hi = count - 1;
  while (lo <= hi) {
    const mid = (lo + hi) >> 1;
    const node = api.getDisplayedRowAtIndex(mid);
    if (!node) {
      return undefined;
    }
    const top = node.rowTop ?? 0;
    const height = node.rowHeight ?? 0;
    const bottom = top + height;
    if (pixel < top) {
      hi = mid - 1;
    } else if (pixel >= bottom) {
      lo = mid + 1;
    } else {
      return node.rowIndex ?? mid;
    }
  }
  const idx = Math.min(Math.max(0, lo), count - 1);
  const node = api.getDisplayedRowAtIndex(idx);
  return node?.rowIndex ?? idx;
}
